<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="ded"><a id="pageiii"></a><em>For the Memory of</em><br/><em>Benn Reyes</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795335020_ded.vue?3bae49bc